/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
import { request as __request } from "../../helpers/api/request";
import type { AccountResponse } from "../../models/auth/AccountResponse";
import type { AccountResponsePageResponse } from "../../models/auth/AccountResponsePageResponse";
import type { AuthenticateRequest } from "../../models/auth/AuthenticateRequest";
import type { AuthenticateResponse } from "../../models/auth/AuthenticateResponse";
import type { CreateRequest } from "../../models/auth/CreateRequest";
import type { ForgotPasswordRequest } from "../../models/auth/ForgotPasswordRequest";
import type { RegisterRequest } from "../../models/auth/RegisterRequest";
import type { ResetPasswordRequest } from "../../models/auth/ResetPasswordRequest";
import type { UpdateRequest } from "../../models/auth/UpdateRequest";
import type { VerifyEmailRequest } from "../../models/auth/VerifyEmailRequest";

export class AccountsService {
  /**
   * @param requestBody
   * @returns AuthenticateResponse Success
   * @throws ApiError
   */
  public static async authenticate(requestBody?: AuthenticateRequest): Promise<AuthenticateResponse> {
    const result = await __request({
      method: "POST",
      path: `/accounts/authenticate`,
      body: requestBody,
    });
    return result.body;
  }

  /**
   * @param requestBody
   * @returns any Success
   * @throws ApiError
   */
  public static async register(requestBody?: RegisterRequest): Promise<any> {
    const result = await __request({
      method: "POST",
      path: `/accounts/register`,
      body: requestBody,
    });
    return result.body;
  }

  /**
   * @param requestBody
   * @returns any Success
   * @throws ApiError
   */
  public static async verifyEmail(requestBody?: VerifyEmailRequest): Promise<any> {
    const result = await __request({
      method: "POST",
      path: `/accounts/verify-email`,
      body: requestBody,
    });
    return result.body;
  }

  /**
   * @param requestBody
   * @returns any Success
   * @throws ApiError
   */
  public static async forgotPassword(requestBody?: ForgotPasswordRequest): Promise<any> {
    const result = await __request({
      method: "POST",
      path: `/accounts/forgot-password`,
      body: requestBody,
    });
    return result.body;
  }

  /**
   * @param requestBody
   * @returns any Success
   * @throws ApiError
   */
  public static async resetPassword(requestBody?: ResetPasswordRequest): Promise<any> {
    const result = await __request({
      method: "POST",
      path: `/accounts/reset-password`,
      body: requestBody,
    });
    return result.body;
  }

  /**
   * @param returnUrl
   * @returns any Success
   * @throws ApiError
   */
  public static async changePassword(returnUrl: string): Promise<any> {
    const result = await __request({
      method: "GET",
      path: `/accounts/change-password`,
      query: {
        returnUrl: returnUrl,
      },
    });
    return result.body;
  }

  /**
   * @param pageSize
   * @param pageNum
   * @param sort
   * @returns AccountResponsePageResponse Success
   * @throws ApiError
   */
  public static async get(pageSize?: number, pageNum?: number, sort?: string | null): Promise<AccountResponsePageResponse> {
    const result = await __request({
      method: "GET",
      path: `/accounts`,
      query: {
        PageSize: pageSize,
        PageNum: pageNum,
        Sort: sort,
      },
    });
    return result.body;
  }

  /**
   * @param requestBody
   * @returns AccountResponse Success
   * @throws ApiError
   */
  public static async create(requestBody?: CreateRequest): Promise<AccountResponse> {
    const result = await __request({
      method: "POST",
      path: `/accounts`,
      body: requestBody,
    });
    return result.body;
  }

  /**
   * @param id
   * @returns AccountResponse Success
   * @throws ApiError
   */
  public static async getById(id: number): Promise<AccountResponse> {
    const result = await __request({
      method: "GET",
      path: `/accounts/${id}`,
    });
    return result.body;
  }

  /**
   * @param id
   * @param requestBody
   * @returns AccountResponse Success
   * @throws ApiError
   */
  public static async update(id: number, requestBody?: UpdateRequest): Promise<AccountResponse> {
    const result = await __request({
      method: "PUT",
      path: `/accounts/${id}`,
      body: requestBody,
    });
    return result.body;
  }

  /**
   * @param id
   * @returns any Success
   * @throws ApiError
   */
  public static async delete(id: number): Promise<any> {
    const result = await __request({
      method: "DELETE",
      path: `/accounts/${id}`,
    });
    return result.body;
  }

  /**
   * @param id
   * @param message
   * @returns any Success
   * @throws ApiError
   */
  public static async disable(id: number, message?: string | null): Promise<any> {
    const result = await __request({
      method: "PATCH",
      path: `/accounts/disable/${id}`,
      query: {
        message: message,
      },
    });
    return result.body;
  }

  /**
   * @param id
   * @returns any Success
   * @throws ApiError
   */
  public static async enable(id: number): Promise<any> {
    const result = await __request({
      method: "PATCH",
      path: `/accounts/enable/${id}`,
    });
    return result.body;
  }

  /**
   * @param pageSize
   * @param pageNum
   * @param sort
   * @returns AccountResponsePageResponse Success
   * @throws ApiError
   */
  public static async getActive(pageSize?: number, searchTerm?: string | null, pageNum?: number, sort?: string | null): Promise<AccountResponsePageResponse> {
    const result = await __request({
      method: "GET",
      path: `/accounts/active`,
      query: {
        PageSize: pageSize,
        SearchTerm: searchTerm,
        PageNum: pageNum,
        Sort: sort,
      },
    });
    return result.body;
  }

  /**
   * @param pageSize
   * @param pageNum
   * @param sort
   * @returns AccountResponsePageResponse Success
   * @throws ApiError
   */
  public static async getDisabled(pageSize?: number, searchTerm?: string | null, pageNum?: number, sort?: string | null): Promise<AccountResponsePageResponse> {
    const result = await __request({
      method: "GET",
      path: `/accounts/disabled`,
      query: {
        PageSize: pageSize,
        SearchTerm: searchTerm,
        PageNum: pageNum,
        Sort: sort,
      },
    });
    return result.body;
  }

  /**
   * @param id
   * @param targetGroup
   * @returns AccountResponse Success
   * @throws ApiError
   */
  public static async updateTargetGroup(id: number, targetGroup?: string | null): Promise<AccountResponse> {
    const result = await __request({
      method: "PUT",
      path: `/accounts/targetgroup/${id}`,
      query: {
        targetGroup: targetGroup,
      },
    });
    return result.body;
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public static async getExcel(): Promise<any> {
    const result = await __request({
      method: "GET",
      path: `/accounts/excelExport`,
    });
    return result.body;
  }
}
